export function percentValue(value: number, totalValue: number, decimals = 2) {
  const percent = (value / totalValue) * 100;
  return roundToPrecision(percent, decimals);
}

export function roundToPrecision(value: number, precision: number = 2): number {
  const multiplier = Math.pow(10, precision);
  // Add/subtract tiny epsilon to avoid floating point precision issues
  // Ensures 1.005 rounds to 1.01 (not 1.00) for proper financial rounding
  const adjusted = value >= 0 ? value + Number.EPSILON : value - Number.EPSILON;
  return Math.round(adjusted * multiplier) / multiplier;
}

export function sumOrNull(val1?: number | null, val2?: number | null): number | null {
  if (val1 == null && val2 == null) {
    return null;
  }
  return (val1 ?? 0) + (val2 ?? 0);
}

export function inRangeOrNull(value: number | null, min?: number, max?: number): number | null {
  if (value == null) {
    return null;
  }
  if (min != null && value < min) {
    return null;
  }
  if (max != null && value > max) {
    return null;
  }
  return value;
}

/**
 * Currency equality to the cent. Values that should agree are often summed separately before they
 * meet, so float noise must not read as a real difference.
 */
export function amountsMatch(a: number, b: number): boolean {
  return Math.abs(a - b) < 0.01;
}
